var React = require('react');

function T2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"T2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"43.17 1.37 21.75 2.72 0 4.09 1.45 27.12 22.39 25.8 45.42 24.35 66.37 23.03 64.92 0 43.17 1.37","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"22","y":"20.69","width":"23.07","height":"62.88","transform":"translate(2.12 -1.3) rotate(2.3)","fill":"#e5c83d"}))])]);
}

T2.defaultProps = {"viewBox":"0 0 66.37 84.01"};

module.exports = T2;

T2.default = T2;
